<template>
  <div id="divisionsPage">
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :resizable-columns="true"
      sort-by="divisions"
      class="elevation-1"
      :footer-props="{
        'items-per-page-text': $t('dataTable.rowsPerPageText'),
        'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
      }"
      :no-data-text="$t('dataTable.noDataText')"
      :headerProps="{
        'sort-by-text': $t('dataTable.sortByText')
      }"
      :no-results-text="$t('dataTable.no_matching_records')"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-row style="width: 100%;">
            <v-col cols="12" sm="6" class="pb-0 pb-sm-3">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('page.events.divisions.search_filter_label')"
                single-line
                :hint="$t('page.events.divisions.search_filter_hint')"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="py-0 py-sm-3">
              <v-dialog v-model="dialog">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" color="secondary" class="float-right">
                    {{ $t("page.events.divisions.new_division") }}
                    <v-icon right dark>mdi-plus-box</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headLine">{{
                      targetDivision.divisionId == -1
                        ? $t("page.events.divisions.new_division")
                        : $t("page.events.divisions.edit_division")
                    }}</span>
                    <v-icon class="ml-auto" @click="dialog = false">fa-times</v-icon>
                  </v-card-title>
                  
                  <v-card-text>
                    <v-container>
                      <v-form ref="divisionForm">
                        <v-row cols="12">
                          <v-col sm="12" md="9" lg="9">
                            <v-text-field
                              :label="
                                $t(
                                  'page.events.divisions.input_division_name_label'
                                )
                              "
                              v-model="targetDivision.divisionName"
                              :rules="[rules.newDivision.required, rules.newDivision.maxLength]"
                              hide-details="auto"
                              @keydown.enter="enterSubmit"
                            ></v-text-field>
                          </v-col>
                          <v-col sm="12" md="3" lg="3">
                            <v-btn
                              @click="validateDivisionForm"
                              :disabled="targetDivision.disabled"
                              color="darken-1" dark small
                            >
                              {{ $t("page.events.divisions.save_name") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-text v-if="targetDivision.divisionId > 0">
                    <v-container>
                      <v-row>
                        <!---v-col cols="12" class="d-flex">
                          <v-btn color="darken-1" dark small @click="close" class="ml-auto">
                            {{ $tc("page.events.divisions.save") }}
                          </v-btn>
                        </v-col-->
                        <v-col cols="12">
                          <v-simple-table>
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left"></th>
                                  <th class="text-left">
                                    {{ $t("page.events.divisions.class_name") }}
                                  </th>
                                  <th style="text-align: center">
                                    {{
                                      $t("page.events.divisions.total_participants")
                                    }}
                                  </th>
                                </tr>
                                <tr>
                                  <th></th>
                                  <th>
                                    <v-text-field 
                                      class="my-2" 
                                      hide-details outlined dense 
                                      v-model="classNameFilterValue" 
                                      type="text" 
                                      :label="$t('page.events.divisions.class_name')"
                                    ></v-text-field>
                                  </th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="cl in filteredItems" :key="cl.name">
                                  <td>
                                    <v-checkbox
                                      :key="cl.id"
                                      :ref="`${targetDivision.divisionId}_${cl.id}`"
                                      v-model="
                                        classStatus[targetDivision.divisionId][cl.id]
                                      "
                                      :disabled="isCbxDiasabled"
                                      @click.prevent="updateClass(cl.id)"
                                    ></v-checkbox>
                                  </td>
                                  <td class="text-left">{{ cl.cName }}</td>
                                  <td>{{ cl.registered }}</td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <!---v-container class="d-flex">
                      <v-btn color="darken-1" dark small @click="close" class="ml-auto">
                        {{ $tc("page.events.divisions.save") }}
                      </v-btn>
                    </v-container--->
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>

      <template v-slot:item.divisionName="{ item }">
        <td :style="{ 'min-width': '200px', 'text-align': 'left' }">{{ item.divisionName }}</td>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar" :timeout="timeout" :color="snackbarColor">
      <span class="snackbar-text" v-html="text"></span>

      <template v-slot:action="{ attrs }">
        <v-btn
          :color="snackbarBtnColor"
          :small="true"
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $tc("common.close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <SGSNotificationConfirm 
        v-if="dialogDelete" :notificationMessage="$t('page.events.divisions.delete_confirm')" 
        small @agree="deleteItemConfirm" @cancel="closeDelete" type="warning" :acept="$t('common.form.delete')" :reject="$t('common.form.cancel')"
    />
    <SGSNotificationError 
        v-if="api.hasErrorMessages" :notificationMessage="$t('page.events.divisions.' + api.message)"
        small type="error" @agree="aceptErrorMessage" :acept="$t('common.acept')"
    />
  </div>
</template>

<script>
import axios from "axios";
import SGSNotificationConfirm from "@/components/custom/notification/NotificationConfirm.vue";
import SGSNotificationError from "@/components/custom/notification/NotificationError.vue";
import { isArray } from 'lodash';

export default {
  components: {
    SGSNotificationConfirm,
    SGSNotificationError
  },
  data: () => ({
    dialog: false,
    dialogDelete: false,
    search: "",

    items: [],
    targetDivision: {
      disabled: true,
      divisionId: -1,
      oldDivisionName: "",
      divisionName: "",
      checkboxInput: null,
      currentClassId: -1,
    },
    classStatus: {},

    editedIndex: -1,
    editedItem: {
      divisionName: 0,
    },
    defaultItem: {
      divisionName: "",
    },
    eventClasses: [],

    snackbar: false,
    snackbarColor: "success",
    snackbarBtnColor: "primary",
    timeout: 2000,

    isLoading: false,
    isCbxDiasabled: false,
    classNameFilterValue: '',

    api: {
      hasErrorMessages: false,
      message: ''
    }
  }),

  computed: {
    rules() {
      return {
        newDivision: {
          required: (v) =>
            !!v || this.$t("page.events.divisions.division_name_required"),
          maxLength: (v) => 
            !v || v.length <= 25 || this.$t("page.events.divisions.division_name_max_length")
        },
      };
    },
    text() {
      return `${this.$t(
        "page.events.divisions.snack_bar_success"
      )} <span class="mdi mdi-check"></span>`;
    },
    item() {
      return this.items.find(
        (obj) => obj.divisionId === this.targetDivision.divisionId
      );
    },
    divisionName() {
      return this.targetDivision.divisionName;
    },
    headerDivision() {
      return this.$t("page.events.divisions.division");
    },
    headers() {
      return [
        {
          text: this.$t("page.events.divisions.division"),
          align: "start",
          sortable: false,
          value: "divisionName",
        },
        {
          text: this.$t("page.events.divisions.classes"),
          align: "start",
          sortable: false,
          value: "classes",
        },
        {
          text: this.$t("page.events.divisions.actions"),
          value: "actions",
          sortable: false,
        },
      ];
    },
    filteredItems() {
      let results = this.eventClasses;
      if(results.length > 0 && (this.classNameFilterValue || "").length > 0) {
        results = results.filter((item) => {
              return (this.classNameFilterValue || "").length > 0 && item.cName.toLowerCase().includes(this.classNameFilterValue.toLowerCase());
        });
      }
      return results;
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
      this.targetDivision.disabled = true;

      try {
        this.$refs.divisionForm.resetValidation();
      } catch (e) {
        //
      }
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    divisionName() {
      this.targetDivision.disabled =
        this.targetDivision.oldDivisionName !=
          this.targetDivision.divisionName &&
        this.targetDivision.divisionName.length > 0
          ? false
          : true;
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize(bandTargetDivision = false) {
      try {
        //const p = this;
        this.isLoading = true;
        const eventClassesResponse = await axios.get(
          `${process.env.VUE_APP_DEV_API_HOST}/laravel/public/api/v1/promoter/eventClass/${this.$route.params.id}`
        );

        this.eventClasses = eventClassesResponse.data.message.data;

        const eventDivisionResponse = await axios.get(
          `${process.env.VUE_APP_DEV_API_HOST}/laravel/public/api/v1/promoter/event/division?eventId=${this.$route.params.id}`
        );

        let items = eventDivisionResponse.data.divisions.map((division) => ({
          divisionId: division.id,
          divisionName: division.name,
          classesId: division.classes.map((clazz) => clazz.fkRaceClassesId),
          cl: division.classes.map((clazz) => {
            return {
              id: clazz.fkRaceClassesId,
              status: false,
            };
          }),
          classes: division.classes
            .map((clazz) => {
              const foundClass = this.eventClasses.find(
                (cls) => cls.id === clazz.fkRaceClassesId
              );
              return foundClass ? foundClass.cName : "";
            })
            .join(", "),
        }));

        this.classStatus = {};
        // Iterate over each division
        items.forEach((division) => {
          // Create a new property for the division in the result object
          this.classStatus[division.divisionId] = {};

          // Iterate over each class
          this.eventClasses.forEach((classObj) => {
            // Check if the class id is in the division's classesId array
            const status = division.classesId.includes(classObj.id);

            // Add the class to the division's property in the result object
            this.classStatus[division.divisionId][classObj.id] = status;
          });
        });
        
        this.items = items;
        if(bandTargetDivision) this.targetDivision.divisionId = bandTargetDivision;
        this.isLoading = false;

        if (this.targetDivision.divisionId > 0) {
          this.classStatus[this.targetDivision.divisionId][this.targetDivision.currentClassId] = this.isClassActive(this.targetDivision.currentClassId);
          this.isCbxDiasabled = false;
        }
      } catch {/*----*/}
    },

    validateDivisionForm() {
      const valid = this.$refs.divisionForm.validate();
      if (valid) {
        this.save();
      }
    },

    async storeDivision() {
      const data = {
        eventId: this.$route.params.id,
        name: this.targetDivision.divisionName,
      };

      const p = this;

      this.isLoading = true;
      await axios.post(
          `${process.env.VUE_APP_DEV_API_HOST}/laravel/public/api/v1/promoter/event/division`,
          data
        )
        .then(function (response) {
          p.initialize(response.data.divisions.id);
          p.snackbar = true;

          //p.targetDivision.divisionId = response.data.divisions.id;
          p.targetDivision.oldDivisionName = p.targetDivision.divisionName;
          p.classNameFilterValue = '';
          p.isLoading = false;
        })
        .catch(
          function (error)
          {
            const errorMessages = error.response.data.message;
            p.renderErrorMessages(errorMessages);
            p.isLoading = false;
          }
        );
    },
    async updateDivision() {
      const data = {
        id: this.targetDivision.divisionId,
        name: this.targetDivision.divisionName,
      };

      const p = this;

      this.isLoading = true;
      await axios.put(
          `${process.env.VUE_APP_DEV_API_HOST}/laravel/public/api/v1/promoter/event/division`,
          data
        )
        .then(function () {
          p.initialize();
          p.targetDivision.oldDivisionName = p.targetDivision.divisionName;
          p.snackbar = true;
          p.isLoading = false;
        })
        .catch(
          function (error)
          {
            const errorMessages = error.response.data.message;
            p.renderErrorMessages(errorMessages);
            p.isLoading = false;
          }
        );
    },
    renderErrorMessages(errorMessages)
    {
      if(!errorMessages) return;

      this.api.success = false;
      this.api.message = isArray(errorMessages) ? errorMessages[0] : errorMessages;
      this.api.hasErrorMessages = true;
    },
    aceptErrorMessage(){
      this.api.hasErrorMessages = false;
      window.location.reload();
    },

    async destroyDivision() {
      const p = this;

      this.isLoading = true;
      await axios
        .delete(
          `${process.env.VUE_APP_DEV_API_HOST}/laravel/public/api/v1/promoter/event/division/${this.targetDivision.divisionId}`
        )
        .then(function () {
          p.initialize();
          p.snackbar = true;
          p.closeDelete();
        })
        .catch(
          function (error)
          {
            const errorMessages = error.response.data.message;
            p.renderErrorMessages(errorMessages);
            p.isLoading = false;
          }
        );
    },
    async addDivisionClass(classId) {
      const data = {
        groupId: this.targetDivision.divisionId,
        classId: classId,
      };

      const p = this;

      this.isLoading = true;
      await axios.post(
          `${process.env.VUE_APP_DEV_API_HOST}/laravel/public/api/v1/promoter/event/division/class`,
          data
        )
        .then(function () {
          p.initialize();
          p.snackbar = true;

          const refName = `${p.targetDivision.divisionId}_${classId}`;
          p.$refs[refName][0].$el.querySelector(
            'input[type="checkbox"]'
          );
        })
        .catch(
          function (error)
          {
            const errorMessages = error.response.data.message;
            p.renderErrorMessages(errorMessages);
            p.isLoading = false;
          }
        );
    },
    async removeDivisionClass(classId) {
      const p = this;

      this.isLoading = true;
      await axios.delete(
          `${process.env.VUE_APP_DEV_API_HOST}/laravel/public/api/v1/promoter/event/division/class/${this.targetDivision.divisionId}/${classId}`
        )
        .then(function () {
          p.initialize();
          p.snackbar = true;
        })
        .catch(
          function (error)
          {
            const errorMessages = error.response.data.message;
            p.renderErrorMessages(errorMessages);
            p.isLoading = false;
          }
        );
    },

    isClassActive(classId) {
      const r = this.item.classesId.includes(classId);
      return r;
    },

    updateClass(classId) {
      const refName = `${this.targetDivision.divisionId}_${classId}`;
      let checkboxInput = this.$refs[refName][0].$el.querySelector(
        'input[type="checkbox"]'
      );

      this.isCbxDiasabled = true;

      this.targetDivision.checkboxInput = checkboxInput;
      this.targetDivision.currentClassId = classId;

      if (!this.isClassActive(classId)) {
        this.addDivisionClass(classId, checkboxInput);
      } else {
        this.removeDivisionClass(classId, checkboxInput);
      }
    },

    editItem(item) {
      this.targetDivision.divisionId = item.divisionId;
      this.targetDivision.oldDivisionName = item.divisionName;
      this.targetDivision.divisionName = item.divisionName;

      this.isCbxDiasabled = false;
      this.classNameFilterValue = '';
      this.dialog = true;
    },

    deleteItem(item) {
      this.targetDivision.divisionId = item.divisionId;
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.destroyDivision();
    },

    close() {
      this.dialog = false;
      this.targetDivision.divisionName = "";
      this.targetDivision.divisionId = -1;
    },

    closeDelete() {
      this.dialogDelete = false;
      this.targetDivision.divisionId = -1;
      this.targetDivision.divisionName = "";
    },

    save() {
      this.targetDivision.disabled = true;

      if (this.targetDivision.divisionId == -1) {
        this.storeDivision();
      } else {
        this.updateDivision();
      }
    },

    enterSubmit(event) {
      event.preventDefault();
      this.validateDivisionForm();
    }
  },
};
</script>

<style lang="scss">
#divisionsPage {
  .snackbar-text {
    color: "black" !important;
  }
  .v-toolbar__content {
    padding: 20px !important;
  }
  @media only screen and (max-width: 599px) {
    .v-data-table {
      header.v-toolbar {
        height: auto !important;
        .v-toolbar__content {
          height: auto !important;
        }
      }
    }
  }
}
</style>
<style scoped>
.v-dialog.v-dialog--active {
  padding: 5px;
}
</style>